import { Box, Grid2, Typography } from "@mui/material";
import BinarySignalStatusBarChart from "./BinarySignalStatusBarChart";
import BinarySignalsSelection from "./BinarySignalsSelection";
import { useEffect, useState } from "react";
import TimeAxis from "./TimeAxis";
import { availableBinarySignalColors, colorForNoDataBinarySignal } from "../../../../DigitalTwin/TabsSection/BatteryVitals/_Constants";
import CartLoader from "../../../../../Helper/Loaders/CartLoader";
import { formatBinarySegmentsForChart, prepareSegmentsFromBinarySignalsData } from "../../../../../Helper/DigitalTwin/DigitalTwinFunctions";

const BinarySignals = ({ isLoading, selectedSignals, setSelectedSignals, allBinarySignals, binarySignalsData, selectedDate, primaryGranularity, handleSelectionOnClick }) => {

    const [allowDataDisplay, setAllowDataDisplay] = useState(primaryGranularity === 'raw');
    const [isBinarySignalDataLoading, setIsBinarySignalDataLoading] = useState(true);
    const [signalsChartData, setSignalsChartData] = useState({});

    const resetSignalsData = async () => {
        setIsBinarySignalDataLoading(true);
        if (!allowDataDisplay) {
            setIsBinarySignalDataLoading(false);
            return;
        }

        const segments = prepareSegmentsFromBinarySignalsData(binarySignalsData);
        const finalPreparedSignals = {};
        selectedSignals.forEach(selectedSignal => {
            const possibleValues = Object.values(selectedSignal.possibleValues);
            const statusColorMap = {};
            possibleValues.forEach((status, index) => {
                statusColorMap[status] = availableBinarySignalColors[index % availableBinarySignalColors.length];
            });
            statusColorMap['noData'] = colorForNoDataBinarySignal;
            finalPreparedSignals[selectedSignal.key] = {
                title: selectedSignal.label,
                segments: formatBinarySegmentsForChart(segments[selectedSignal.key], selectedDate.value),
                colors: statusColorMap,
            }
        });
        setSignalsChartData(finalPreparedSignals);
        setIsBinarySignalDataLoading(false);
    }

    useEffect(() => {
        setAllowDataDisplay(primaryGranularity === 'raw');
    }, [primaryGranularity]);

    useEffect(() => {
        if (binarySignalsData) {
            resetSignalsData();
        }
    }, [binarySignalsData]);

    return (
        <Grid2>
            <Grid2 container justifyContent={'space-between'} alignItems={'center'} mb={1.5}>
                <Typography variant="fw500s16c000000" sx={{ lineHeight: '20px' }}>Categorical Signals</Typography>
                <Grid2>
                    <BinarySignalsSelection
                        itemList={allBinarySignals}
                        selectedItems={selectedSignals}
                        applySelectedItems={setSelectedSignals}
                        handleSelectionOnClick={handleSelectionOnClick}
                    />
                </Grid2>
            </Grid2>
            {isLoading || isBinarySignalDataLoading ? (
                <Box sx={{ minHeight: '360px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <CartLoader />
                </Box>
            ) : (
                <>
                    {!allowDataDisplay && <Grid2 container justifyContent={'center'} alignItems={'center'} height={100}>
                        <Box
                            sx={{
                                backgroundColor: "#F9F9F9",
                                padding: "2px 12px",
                                borderRadius: "16px",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                            }}
                        >
                            <Typography variant="fw400s12c494949" sx={{ lineHeight: '24px' }}>
                                Categorical Signals are only available in raw format
                            </Typography>
                        </Box>
                    </Grid2>}
                    {allowDataDisplay && (
                        <Grid2 container id="binary-signals-charts-container">
                            <Box sx={{ maxHeight: '400px', overflow: 'hidden', width: '100%' }}>
                                <Box sx={{ height: '100%', overflowY: 'auto', overflowX: 'hidden', width: '100%' }}>
                                    {/* height adjusted to 101% to avoid glitch due to tooltip height */}
                                    <Grid2 container gap={2} py={2} px={3.5} height={'101%'}>
                                        {(selectedSignals ?? []).map((selectedSignal) => {
                                            if (!signalsChartData[selectedSignal.key]) {
                                                return <></>;
                                            }
                                            const signalData = signalsChartData[selectedSignal.key];
                                            return <BinarySignalStatusBarChart
                                                key={Math.random()}
                                                chartId={`binary-signal-chart-${selectedSignal.key}`}
                                                title={signalData.title}
                                                segments={signalData.segments}
                                                colors={signalData.colors}
                                            />
                                        })}
                                    </Grid2>
                                </Box>
                            </Box>
                            <Box sx={{
                                width: '100%',
                                pl: 13.5,
                                pr: 14.5,
                                mx: 'auto',
                                my: 2,
                            }}>
                                <TimeAxis />
                            </Box>
                        </Grid2>
                    )}
                </>
            )}

        </Grid2>
    )
};

export default BinarySignals;
